"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutRoute = void 0;
var React = __importStar(require("react"));
var useEffect = React.useEffect;
var loading_part_1 = require("../parts/loading.part");
var client_1 = require("@apollo/client");
var auth0_react_1 = require("@auth0/auth0-react");
var LogoutRoute = function (props) {
  var client = (0, client_1.useApolloClient)();
  var logout = (0, auth0_react_1.useAuth0)().logout;
  useEffect(function () {
    client.resetStore();
    logout({
      returnTo: process.env.AUTH0_LOGOUT_RETURNTO,
      client_id: process.env.AUTH0_CLIENT_ID
    });
  });
  return React.createElement(loading_part_1.LoadingPart, null);
};
exports.LogoutRoute = LogoutRoute;
exports.default = exports.LogoutRoute;